<template>
  <div class="communication-statistics">
    <CmTabs
      v-model="activeTab"
      :tabs="tabs"
      type="3"
    >
      <template #cm-tabs-between-content>
        <slot />
        <TabsHeader
          slot="cm-tabs-between-content"
          :title="title"
        />
      </template>
      <component
        :is="`${item.component}Tab`"
        v-for="(item, index) in tabs"
        :key="index"
        :slot="item.id"
      />

      <StatisticsFiltration
        v-if="activeTab"
        slot="cm-tabs-header-inside"
        hideNameSearch
        hideTagFilter
        hideProviderFilter
        class="promo-statistics__toolbar"
      />
    </CmTabs>
  </div>
</template>

<script>
import TabsHeader from "./tabs/TabsHeader.vue";
import CmTabs from "@/components/library/CmTabs.vue";

import GeneralTab from "./tabs/general/Index.vue";
import DeliveryTab from "./tabs/delivery/Index.vue";
import OpensTab from "./tabs/opens/Index.vue";
import ClickedTab from "./tabs/visits/Visits.vue";
import ErrorsTab from "./tabs/errors/Index.vue";
import UnsubscribesTab from "./tabs/unsubscribes/Index.vue";
import ClickMapTab from "./tabs/clickmap/Index.vue";

import StatisticsFiltration from "@/components/statistics/general/Filtration.vue";
import tabsConfig from "./commTabsConfig";
import { mapActions, mapState, mapMutations } from "vuex";
import statisticsMixin from "@/views/statistics/statisticsMixin";

export default {
  components: {
    CmTabs,
    TabsHeader,
    GeneralTab,
    DeliveryTab,
    OpensTab,
    ClickedTab,
    UnsubscribesTab,
    ErrorsTab,
    ClickMapTab,
    StatisticsFiltration,
  },

  mixins: [statisticsMixin],

  data() {
    return {
      activeTab: 0,
      titles: {
        general: "",
        delivered: "Статистика по доставке за период",
        opens: "Открытия за период",
        clicked: "Переходы за период",
        unsubscribers: "Отписки за период",
        geography: "Доставлено по регионам за период",
        errors: "Ошибки за период",
      },
    };
  },

  computed: {
    ...mapState({
      statDateRange: (state) => state.stat.statDateRange,
      selectedPeriod: (state) => state.stat.statDateText,
      groupby: (state) => state.stat.groupby,
      activeType: (state) => state.stat.activeType,
    }),
    tabs() {
      if (tabsConfig[this.activeType] && !this.$route.params.id)
        return tabsConfig[this.activeType].filter((i) => i.id !== "clickMap");
      return tabsConfig[this.activeType] || tabsConfig.default;
    },

    title() {
      const title = this.titles[this.tabs[this.activeTab].id];
      if (!title) return "";

      return `${title} ${this.selectedPeriod}`;
    },
  },

  props: {
    campstatsaudit: {
      type: Object,
      default: () => {},
    },
  },

  watch: {
    campstatsaudit() {
      this.reloadStat();
    },
    statDateRange() {
      if (!(this.$route.name === "statistics-general"))
        this.reloadStat();
    },
    getStatDateRange() {
      if (this.$route.name === "statistics-general")
        this.updateGroupbyDetailsGeneral();
    },
  },

  mounted() {
    if (this.$route.name === "statistics-general")
      this.getAllCampStats();
    else this.reloadStat();
  },

  methods: {
    ...mapActions({
      getStatDetails: "getStatDetails",
    }),
    ...mapMutations({
      statMutation: "statMutation",
    }),
    async reloadStat() {
      if (!_.isEmpty(this.campstatsaudit)) {
        this.getStatDetails({
          requestBody: this.campstatsaudit[this.activeType],
          type: "details",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.statistics-filtration {
  padding: 0;
}

::v-deep.promo-statistics {
  &__toolbar {
    display: flex;
    align-items: center;
    margin-left: auto;
    border-bottom: 1px solid $color_border;

    .statistics-filtration__popup {
      min-width: 600px;
      right: 0;
      left: unset;
    }

    .icon--export {
      width: 14px;
      height: 14px;
      margin-top: 2px;
    }
    .toolbar__item {
      padding: 10px 0;
      margin-left: 27px;
    }
    .toolbar {
      flex-wrap: unset;
    }
  }
}
</style>

<style lang="scss">
.communication-statistics {
  margin: 0 14px;
  height: 100%;
  .cm-tabs-container {
    padding: 0 20px;
  }
  .spinner.center {
    top: 50px;
  }
}
</style>